import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebButtonModule } from '../../components/web-button/web-button.module';
import { SuccessComponent } from './success.component';

@NgModule({
  declarations: [
    SuccessComponent
  ],
  imports: [
    CommonModule,
  WebButtonModule
  ],
  exports: [
    SuccessComponent
  ]
})
export class SuccessModule { }


